import { ADMIN_ORG_ID_KEY } from "@/core/constants";
import { deleteCookie, getCookie, setCookie } from "./cookies";

/**
 * The org a Storydoc admin switched to — what the API receives as `Orgid`.
 *
 * Read once per tab, then kept. The cookie and localStorage entry are shared by
 * every tab, but the org switcher reloads only its own: reading them on every
 * request sent an editor tab that was already open into the org picked in
 * another tab, where its story does not exist. Each save of that tab then
 * failed (404/403) and its edits were gone on reload.
 */
let tabAdminOrgId: string | undefined;

export const getAdminOrgId = (): string => {
  tabAdminOrgId ??=
    getCookie(ADMIN_ORG_ID_KEY) || localStorage.getItem(ADMIN_ORG_ID_KEY) || "";
  return tabAdminOrgId;
};

export const setAdminOrgId = (orgId: string) => {
  setCookie({ name: ADMIN_ORG_ID_KEY, value: orgId, days: 365 });
  localStorage.setItem(ADMIN_ORG_ID_KEY, orgId);
  tabAdminOrgId = orgId;
};

export const clearAdminOrgId = () => {
  deleteCookie(ADMIN_ORG_ID_KEY);
  localStorage.removeItem(ADMIN_ORG_ID_KEY);
  tabAdminOrgId = "";
};
